module.exports = __webpack_public_path__ + "media/assets/images/group_line_end-bc39a9239fc1eda24d81e65357219a6b.png";